<div class="main">
  <sbb-info-banner-widget></sbb-info-banner-widget>
  <div class="app-main">
    <!-- Startup the splash loading screen and show the loading process to the user -->
    <startup></startup>

    <!-- The Angular2-Notification Module is created on top level and is available for
           any pages and components -->
    <simple-notifications></simple-notifications>

    <!-- All child views/components/templates/elements of app.component
           will be rendered inside router-outlet -->
    <router-outlet></router-outlet>
  </div>
</div>
